import React, { useEffect } from 'react';
import { useSiteSettings } from '@/context/SiteSettingsContext';

export default function Terms() {
  const s = useSiteSettings();
  const email = s.email || 'pkruparthenterprisepvtltd@gmail.com';
  const companyName = s.company_name || 'PKRUPARTH ENTERPRISE PVT. LTD.';
  const brandName = s.brand_name || 'NKP VENTURES';

  useEffect(() => { document.title = `Terms & Conditions | ${brandName}`; }, [brandName]);

  return (
    <div className="bg-white">
      <div className="pt-32 pb-16 bg-[#F7FAFC] border-b border-[#E5E7EB]">
        <div className="max-w-4xl mx-auto px-6">
          <p className="overline-label text-[#0E5A57] mb-3">Legal</p>
          <h1 className="font-serif text-4xl lg:text-5xl font-bold text-[#153E5C]">Terms & Conditions</h1>
          <p className="text-[#6B7280] mt-4 font-sans text-sm">Last updated: January 2025</p>
        </div>
      </div>
      <div className="py-16 max-w-4xl mx-auto px-6 lg:px-8 prose-pkepl">
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using the {brandName} website, you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our website.</p>

        <h2>2. Use of the Website</h2>
        <p>This website is provided for informational purposes about {brandName}'s services. You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of others.</p>

        <h2>3. Intellectual Property</h2>
        <p>All content on this website, including text, graphics, logos, images, and software, is the property of {companyName} and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.</p>

        <h2>4. Service Inquiries</h2>
        <p>Submitting an inquiry through our website does not constitute a binding agreement for services. All service engagements are subject to a separate written agreement between {brandName} and the client.</p>

        <h2>5. Confidentiality</h2>
        <p>Any information you share with us through our website or in connection with a service inquiry will be treated as confidential and will not be disclosed to third parties without your consent, except as required by law.</p>

        <h2>6. Disclaimer of Warranties</h2>
        <p>This website is provided "as is" without any warranties, express or implied. {brandName} does not warrant that the website will be uninterrupted, error-free, or free of viruses or other harmful components.</p>

        <h2>7. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, {brandName} shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of this website or reliance on any information provided herein.</p>

        <h2>8. Third-Party Links</h2>
        <p>Our website may contain links to third-party websites. These links are provided for your convenience, and {brandName} does not endorse or assume responsibility for the content of linked websites.</p>

        <h2>9. Governing Law</h2>
        <p>These Terms and Conditions are governed by the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Ahmedabad, Gujarat, India.</p>

        <h2>10. Changes to Terms</h2>
        <p>We reserve the right to modify these Terms and Conditions at any time. Continued use of the website after changes constitutes acceptance of the modified terms.</p>

        <h2>11. Contact</h2>
        <p>For questions about these Terms, contact us at <a href={`mailto:${email}`}>{email}</a>.</p>
      </div>
    </div>
  );
}
